import { createSvgComponent } from "../../icon/createSvgComponent";
import CopyPaste from "@core/__generated__/icon/figma/copy-paste.svg";
export default createSvgComponent(CopyPaste);